<ng-container *ngVar="subMenuActions$ | async as resolvedSubmenu">
  <app-dropdown-option
    class="dropdown-option"
    [attr.data-test-id]="menuAction?.id"
    [class.cursor-default-important]="shouldDisableOption"
    [menuAction]="menuAction"
    [context]="context"
    [submenuDirection]="resolvedSubmenu?.menuActions?.length ? 'right' : undefined"
    (click)="handleClick($event)"
  >
    <ng-container *ngTemplateOutlet="menuAction?.template"></ng-container>
  </app-dropdown-option>

  @if (resolvedSubmenu?.menuActions?.length) {
    <div #submenu class="sub-menu absolute whitespace-nowrap bottom-0 {{ getSubmenuPositionClass(resolvedSubmenu?.position) }}">
      <app-dropdown-options-backdrop>
        @if (menuAction?.searchEnabled) {
          <app-dropdown-search-input
            class="w-full min-w-56"
            [formControl]="searchField"
            [placeholder]="menuAction?.searchFieldPlaceholder | translate"
            (click)="activateMenu(); $event.stopPropagation()"
          ></app-dropdown-search-input>
        }

        @for (action of displayedData$ | async; track $index) {
          <app-dropdown-option-with-submenu
            [menuAction]="action"
            [context]="context"
            [selected]="selected"
            (nestedDropdownClick)="nestedClick()"
          ></app-dropdown-option-with-submenu>
        }

        @if (menuAction?.bottomActions?.length) {
          @for (action of menuAction.bottomActions; track $index) {
            <app-dropdown-option-with-submenu
              [menuAction]="action"
              [context]="context"
              [selected]="selected"
              (nestedDropdownClick)="nestedClick()"
              (click)="$event.preventDefault()"
            ></app-dropdown-option-with-submenu>
          }
        }
      </app-dropdown-options-backdrop>
    </div>
  }
</ng-container>
